<ng-container *ngIf="form" [formGroup]="form">
    <mat-form-field appearance="fill" class="w-full mb-2">
        <mat-label>{{ label }}</mat-label>
        <input matInput [id]="id" [formControlName]="name" [matAutocomplete]="auto" [required]="required" [placeholder]="placeholder" />
        <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption [displayWith]="displayOption">
            <mat-option *ngFor="let option of filteredOptions" [id]="id + '-' + option.value" [value]="option.value">
                {{ option.label }}
            </mat-option>
            <mat-option *ngIf="filteredOptions.length === 0" [id]="id + '-empty'" disabled>
                No matching option
            </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="control?.invalid" [id]="id + '-error'">{{ errorMessage }}</mat-error>
    </mat-form-field>
</ng-container>